import type {FetchBaseQueryArgs} from '@reduxjs/toolkit/query/react';
import {prepareHeaders} from './prepareHeaders';

export const createBaseQueryArgs = (baseUrl: string): FetchBaseQueryArgs => ({
  baseUrl,
  prepareHeaders,
});
